import React, { FunctionComponent } from "react";
import { MedigapPlan, MedigapPlanType } from "../utils/plans";
import { useTranslate } from "../../../helpers";
import PlanDetailsTable from "./PlanDetailsTable";
import { Tooltip } from "../../../components";

interface PartAandBServicesProps {
  planData: MedigapPlan;
}

const PartAandBServices: FunctionComponent<PartAandBServicesProps> = ({
  planData,
}) => {
  const t = useTranslate();

  const title = (
    <>
      {t("medigap.plan_details.what_you_will_pay_for")}{" "}
      <Tooltip
        inline={true}
        triggerClassName="MedigapPlanDetails__sectionTitleTooltip"
        triggerText={t("medigap.plan_details.part_a_and_b_services")}
        title={t("medigap.plan_details.part_a_and_b_services")}
      >
        <span className="ds-u-font-weight--normal ds-u-sans ds-u-font-size--small">
          {t("medigap.plan_details.part_a_and_b_services_tooltip")}
        </span>
      </Tooltip>
    </>
  );

  const data = [
    {
      property: t("medigap.plan_details.home_health_care"),
      value:
        planData.state === "WI"
          ? [
              {
                property: t(
                  "medigap.plan_details.home_medicare_covered_visits"
                ),
                value: t(planData.home_health),
              },
              planData.home_health_add_40
                ? {
                    property: t("medigap.plan_details.home_additional_40"),
                    value: t(planData.home_health_add_40),
                  }
                : null,
              planData.home_health_after_40
                ? {
                    property: t("medigap.plan_details.home_after_40"),
                    value: t(planData.home_health_after_40),
                  }
                : null,
              planData.home_health_add_365
                ? {
                    property: t("medigap.plan_details.home_additional_365"),
                    value: t(planData.home_health_add_365),
                    hide:
                      planData.state === "WI" &&
                      planData.plan_type !== MedigapPlanType.WI_HIGH_DEDUCTIBLE,
                  }
                : null,
              planData.home_health_after_365
                ? {
                    property: t("medigap.plan_details.home_after_365"),
                    value: t(planData.home_health_after_365),
                  }
                : null,
            ]
          : t(planData.home_health),
    },
    {
      property: t("medigap.plan_details.durable_medical_equipment"),
      tooltip: t("medigap.plan_details.durable_medical_equipment_tooltip"),
      value: [
        {
          property: t("medigap.plan_details.first"),
          value: t(planData.dme_first),
        },
        {
          property: t("medigap.plan_details.then"),
          value: t(planData.dme_remainder_then),
        },
      ],
    },
  ];

  const footerNotes: { text: string | JSX.Element; id?: string }[] = [];

  return <PlanDetailsTable table={{ title, data, footerNotes }} />;
};

export default PartAandBServices;
